<template>
  <v-footer dark padless >
    <v-card flat tile class="white--text text-center" style="background-color: #F4F1F8;">
      <!-- <v-card-text>
        <v-btn
          v-for="(icon, i) in icons"
          :key="i"
          class="mx-4 white--text"
          :href="icon.link"
          target="_blank"
          icon
        >
          <v-icon size="24px">{{ icon.text }}</v-icon>
        </v-btn>
      </v-card-text> -->

      <!-- <v-divider></v-divider> -->

      <v-card-text class="white--text">
      <strong>Hak Cipta Terpelihara  {{ new Date().getFullYear() }} <v-icon color="black" size="small">mdi-registered-trademark</v-icon> - Jabatan Perangkaan Malaysia</strong>
      <br><strong> app version : {{ appVersion }}  </strong>
      <br><strong> data version : {{ dataVersion }}  </strong>
    </v-card-text>

    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
</style>

<script>
export default {
  data: () => ({
    appVersion: process.env.VUE_APP_VERSION,
    dataVersion: process.env.VUE_APP_DATA_VERSION,
    icons: [
      {
        text: "mdi-facebook",
        link: "",
      },
      {
        text: "mdi-twitter",
        link: "",
      },
      {
        text: "mdi-linkedin",
        link: "",
      },
      {
        text: "mdi-instagram",
        link: "https://instagram.com/joabson_arley/",
      },
    ],
  }),
};
</script>
